import { Quote } from '@app/models/quote.model'

export enum QUOTE_ACTIONS {
	LOAD = '[Quote] Load',
	UPDATE = '[Quote] Update',
	RESET_START_DATE = '[Quote] Reset Start Date',
}

export namespace QuoteAction {
	export class Load {
		static readonly type = QUOTE_ACTIONS.LOAD
		constructor(public payload: Quote) {}
	}

	export class Update {
		static readonly type = QUOTE_ACTIONS.UPDATE
		constructor(public payload: Partial<Quote>) {}
	}

	export class ResetStartDate {
		static readonly type = QUOTE_ACTIONS.RESET_START_DATE
	}
}
